import { State } from 'src/types'
import { hamidashiOfWingTip } from '../hamidashi/wingTip'
import { wingTipBackStyle } from '../wingTipBackStyle'
import { middleFingerLeft, middleFingerRight } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/middleFinger'
import { ringFingerLeft, ringFingerRight } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/ringFinger'
import { indexFingerLeft } from '../indexFinger'
import { littleFingerLeft, littleFingerRight } from '../littleFinger'
import { thumbAndWristBelt, thumbOut } from '../thumbAndWristBelt'
import { listBelt } from '../listBelt'
import { indexFingerPad } from '../fingerCoverOrPad/indexFingerPad'
import { catchFace2 } from '../catchFace2'
import { edgeOfBeltBackStyle } from '../edge/edgeOfBeltBackstyle'
import { edgeOfWrist } from '../edge/edgeOfWrist'
import { middleFingerPad } from '../fingerCoverOrPad/middleFIngerPad'
import { thumbHook } from '../hooks/thumbHook'

// 王冠モデル
export const crownBackStyleDrawer = async (ctx: CanvasRenderingContext2D, state: State, needCatchFaceWrap: boolean): Promise<void> => {
  if (state.backStyle?.value !== 'crownBackStyle' && state?.baseModel?.backStyle !== 'crownBackStyle') return

  const isIndexFingerPad = ['indexPad'].includes(state.fingerGuardType?.value)
  const isMiddleFingerPad = ['middlePad'].includes(state.fingerGuardType?.value)
  const printLeatherTypeValue = state.printLeatherType?.value

  // 親指指袋_手口ベルト(下地)
  await thumbAndWristBelt(ctx, state.thumbWeb?.color, state.stitch.color, printLeatherTypeValue)
  // 親指＿外
  await thumbOut(ctx, state.thumbOut.color, printLeatherTypeValue)

  if (['normal', 'unselected', undefined].includes(state.beltType?.value)) {
    await listBelt(ctx, state.listBelt.color, state.stitch.color, printLeatherTypeValue)
  }

  // 人差し指＿左
  await indexFingerLeft(ctx, state.indexLeftMiddleRight?.color, printLeatherTypeValue)

  // 中指＿右
  await middleFingerRight(ctx, state?.indexLeftMiddleRight?.color, printLeatherTypeValue)
  // 中指＿左
  await middleFingerLeft(ctx, state?.middleLeftRingRight?.color, printLeatherTypeValue)

  // 薬指＿右
  await ringFingerRight(ctx, state?.middleLeftRingRight?.color, printLeatherTypeValue)
  // 薬指＿左
  await ringFingerLeft(ctx, state?.ringLeftLittleRight?.color, printLeatherTypeValue)

  // 小指＿右
  await littleFingerRight(ctx, state?.ringLeftLittleRight?.color, printLeatherTypeValue)
  // 小指＿左
  await littleFingerLeft(ctx, state?.littleOut?.color, printLeatherTypeValue)

  await wingTipBackStyle(ctx, state.indexWeb.color, printLeatherTypeValue)

  hamidashiOfWingTip(ctx, state.hamidashi.color)
  // 指当て
  isMiddleFingerPad && middleFingerPad(ctx, state.indexCover.color, state.stitch.color, -165, 90, -15)
  isIndexFingerPad && indexFingerPad(ctx, state.indexCover.color, state.stitch.color)

  // 捕球面 / ウェブ下折り返し
  catchFace2(ctx, state.catchFace.color, state.stitch.color, needCatchFaceWrap)
  edgeOfBeltBackStyle(ctx, state.edge.color, state.stitch.color)
  edgeOfWrist(ctx, state.edge.color, state.stitch.color)

  thumbHook(ctx, state.thumbHook.color, 110, -310, 15) // 先端 // 親指掛け紐
  thumbHook(ctx, state.thumbHook.color, -14, 30, 0) //手元
}
